module.exports = __webpack_public_path__ + "static/img/identity3.1613de8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/identity3.png
// module id = XY4g
// module chunks = 1